var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMindBodyLowBattery = function SvgMindBodyLowBattery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.361 5.613h-2.013v-.786a.66.66 0 0 0-.667-.667h-1.933a.66.66 0 0 0-.667.667v.786h-2.013a2.345 2.345 0 0 0-2.334 2.334v18.88a2.345 2.345 0 0 0 2.334 2.333h7.293a2.345 2.345 0 0 0 2.333-2.333V7.947a2.345 2.345 0 0 0-2.333-2.334Zm1 21.214c0 .546-.453 1-1 1h-7.293c-.547 0-1-.454-1-1V7.947c0-.547.453-1 1-1h7.293c.547 0 1 .453 1 1v18.88Zm-1.333-3.014v2.04a.66.66 0 0 1-.667.667h-5.293a.66.66 0 0 1-.667-.666v-2.04a.66.66 0 0 1 .667-.667h5.293a.66.66 0 0 1 .667.667Z",
    fill: "currentColor"
  })));
};
export default SvgMindBodyLowBattery;